module.exports = "<!--\r\nAuto-generated\r\nDo not edit!!!\r\n-->\r\n<span [formGroup]=\"formGroup\">\r\n    <kendo-slider\r\n        #slider\r\n        [min]=\"config.min\"\r\n        [max]=\"config.max\"\r\n        [showButtons]=\"config.showButtons\"\r\n        [smallStep]=\"config.smallStep\"\r\n        [vertical] = \"config.vertical\"\r\n        [formControlName]=\"id\"\r\n        (valueChange)=\"valueChange($event)\">\r\n    </kendo-slider>\r\n</span>"


//////////////////
// WEBPACK FOOTER
// C:/Repositories/wfa3/SupplierPortal/app/src/app/shared/components/slider/slider.component.html
// module id = ../../../../../src/app/shared/components/slider/slider.component.html
// module chunks = main